import React, { useEffect, useRef, useState } from "react";
import Select from "./../../ReusableComp/Select";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { PopUpAlert } from "../../ReusableComp/PopUpModal";
import EventMeetCase  from "./EventMeetCase";
import EventNotMeetCase from "./EventNotMeetCase";
import axios from "../../../axios-interceptor";
import { Editor } from '@tinymce/tinymce-react';
import { EVENT_CLASSIFICATION_GRADE_CTCAE, EVENT_CLASSIFICATION_LEVEL_BRIGHTON, EVENT_CLASSIFICATION_AESI, base_url, TINY_API_KEY } from "../../../utilities";
import { allAeBankEvents,  getAllEventClassification, } from "../../../Redux/actions/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { MeddraDetails } from "../../Quality_Reviewer/ReviewList";


const PMSAddEvent = (props) => {
    const dispatch = useDispatch();
    const [eventName, setEventName] = useState("");
    const [selectedKey, setSelectedKey] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [meddra, setMeddra] = useState({});
    const [textAreas, setTextAreas] = useState([""]);
    const [textAreaMeetCase, setTextAreaMeetCase] = useState([""]);
    const [textAreasNotMeetCase, setTextAreasNotMeetCase] = useState([""]);
    const [othersTextArea, setOthersTextArea] = useState()
    const [eventClass, setEventClass] = useState()
    const [aesiData, setAESIData] = useState([])
    const [btnTitle, setBtnTitle] = useState("");
    const [getVlaue, setGetValue] = useState("");
    const [openDeleteNew, setOpenDeleteNew] = React.useState(false);
    const [deleteNewTextArea, setDeleteNewTextArea] = useState(null);
    const getClassifications = useSelector((state) => state.getAllClassifications);
    const myNodeRef = useRef(null);
    const [encodeMeddrabtn, setEncodeMeddrabtn] = useState(true);
  const [value, setValue] = useState("");
  const [isBtn, setIsBtn] = useState(false)
  const [masterArray2, setMasterArray2] = useState([])
  const [reviewedDtls, setReviewedDtls] = useState(false);
  const [meddraClassification, setMeddraClassification] = useState();
    const [medView, setMedView] = useState(true)
    const [loadFlag, setLoadFlag] = useState(false)
    const[noRecordsFlag, setNoRecordsFlag] = useState(false)

    let concatinatedArray = [...textAreaMeetCase, ...textAreasNotMeetCase]
    let allValuesNotEmpty = concatinatedArray.every((value) => value !== '');
    let textareaNotEmplty = textAreas.every((value) => value !== '');
    useEffect(() => {
      
        dispatch(allAeBankEvents())
        dispatch(getAllEventClassification())
      }, [dispatch])
let blankTextAreas = textAreas.some(i => i=='')

  const options = getClassifications && getClassifications.map((event) => ({
    value: event.event_classification_id,
    label: event
  }));

  const handleTextAreaChange = (index, e, textAreaValue) => {
    const value = e.target.value;
    setGetValue(value)
    const updatedTextAreas = [...textAreas];
    updatedTextAreas[index] = value;
    setTextAreas(updatedTextAreas)


  };
    const handleAdverseEvent = (e) => {
        const value = e.target.value.replace(/\d/g, '');
        
        if (value !== '') {
          setEventName(value);
    
        } else if (value === '') {
          setEventName('');
    
        }
      };
      const handleOptionSelect = (event, option, key) => {
        setMeddraDisbl(false)
        setEventClass(option === 'Brighton' ? EVENT_CLASSIFICATION_LEVEL_BRIGHTON : option === 'CTCAE' ? EVENT_CLASSIFICATION_GRADE_CTCAE : option === 'AESI' ? EVENT_CLASSIFICATION_AESI : option === 'Select Classification' ? '' : '')
        setSelectedKey(key);
        setTextAreas([""])
        setTextAreaMeetCase([""])
        setTextAreasNotMeetCase([""])
        setOthersTextArea('')
        setGetValue('');
      };

      const addTextArea = () => {
        setTimeout(() => {
          setTextAreas((prevTextAreas) => [...prevTextAreas, ""]);
        }, 300);
      };
      const meetCaseDef = (props) => {
        setTextAreaMeetCase(props)
      }
      
      const notMeetCaseDef = (props) => {
        setTextAreasNotMeetCase(props)
      }
      function handleOption(e) {
        setSearchTerm(e.llt);
        setShowPopup(false)
        setBtnTitle(e.llt)
        setMeddra({
          label: e.llt,
          value: e.meddra_classification_master_id,
        })
      }
      
      function handleDropDown() {
        setShowPopup(!showPopup)
        setSearchTerm('');
    
      }

 
  function handleSearch(e) {
    setSearchTerm(e.target.value);
  }
  
  const handleNewTextAreaDelete = (textareas, index) => {
    setDeleteNewTextArea({ textareas: textareas, index: index })
    setOpenDeleteNew(true);
  }

  const deleteNewTextBoxes = () => {
    deleteNewTextArea.textareas.splice(deleteNewTextArea.index, 1)
    setDeleteNewTextArea(deleteNewTextArea.textareas, null)
    setOpenDeleteNew(false);
  }

  const handleTextareaKeyDown = (e) => {
    if (e.key === ' ' && !getVlaue.trim() && !e.target.selectionStart) {
      e.preventDefault();
    }
  };
  const handleEditorChange = (content, editor) => {
    let value = content;
    let data = (aesiData.aesi_description = value)

    setOthersTextArea(data)

  };


  let createNewEventObj = {
    "aebank_event_title": eventName,
    "event_classification_id": selectedKey,
    "case_definition": eventClass,
    "event_definition": eventClass === EVENT_CLASSIFICATION_GRADE_CTCAE ? textAreas : eventClass === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? [textAreaMeetCase, textAreasNotMeetCase] : [othersTextArea],
    "created_by": localStorage.login_user_name,
    "meddra_llt_master_id": masterArray2.meddra_llt_master_id ? masterArray2.meddra_llt_master_id : null,
    "meddra_mdhier_master_id":masterArray2.meddra_mdhier_master_id ?masterArray2.meddra_mdhier_master_id:null,

  }

  const handleSaveEvent = () => {

    // dispatch(createNewEvent(createNewEventObj))
    axios
      .post(base_url + "aebank/create_aebank_event", createNewEventObj)
      .then((res) => {
        if (res.data.data === "Validation error") {
          toast.error("This Event has already been created.", {
              toastId: 1
          });
          props.setModalOpen(true);
          } else if (
              res.data.message === "Brighton Events Saved" ||
              res.data.message === "CTCAE Events Saved" ||
              res.data.message === "AESI Events Saved"
          ) {
              props.setSaveAlertAdverse(true);
              props.setModalOpen(false);
          }
        }      
         
         )
      .catch((err) => {
        console.log(err);
      });
  };
  const [meddraDetails, setMeddraDetails] = useState([
    {
      "searchTerm": "",
      "current_idx": 0,
      "checkedMeddra":"",
      "medDRAEncode": false,
      "meddraArray": [],
    },
  ]);
const [meddraDisbl, setMeddraDisbl] = useState(true)

 const onEncode2 = (searchTerm, object) => {
  setLoadFlag(true)
  setMedView(false)
    setValue(searchTerm);
    axios
      .post(
        base_url + "meddra-master/fetch_llt_occurences", {
        "llt_name": searchTerm
      }
      )
      .then((res) => {
        let meddraArray = res.data.data
        setLoadFlag(false)
    meddraDetails.map((data, index) => {
      if (data.searchTerm != "" || data.searchTerm !== null) {
        setIsBtn(true)
      }
      else {
        setIsBtn(false)
      }
      if (data.current_idx == object.current_idx) {
        meddraDetails[index].meddraArray = meddraArray;
        setMeddraDetails(meddraDetails)
        if (meddraArray?.length === 1) {
setMasterArray2({
  meddra_llt_master_id: meddraArray[0]?.meddra_llt_master_id,
  index: object.current_idx,
            meddra_mdhier_master_id: meddraArray[0]?.meddra_mdhier_master_id,
            
          })
          
        } else {
          
          setMasterArray2({
            meddra_llt_master_id: null,
            index: object.current_idx,
            meddra_mdhier_master_id: null

          })
        }
      }
    })
  })
  }
  // const handleMeddraClassification1 = (event, index) => {
  //   meddraDetails.map(data => {
  //     if (data.current_idx == index) {
  //       if (event.target.value == "") {
  //         data.meddraArray = []
  //         setValue("")
  //         data.searchTerm = ''
  //         setEncodeMeddrabtn(false)
  //         data.medDRAEncode =false
  //         setMeddraDetails(meddraDetails)
          
  //       } else {
  //         setValue(event.target.value);
  //         data.searchTerm = event.target.value
  //         setEncodeMeddrabtn(true)
  //         setMeddraDetails(meddraDetails)
  //       }
  //     }
  //   })
  // };

  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [dotsFlag, setDotsFlag] = useState(false)
  const [listFlag, setListFlag] = useState(false)

  let debounceTimer;


  const handleMeddraClassification1 = (event, index) => {
    setListFlag(true)
    setDotsFlag(true)

    const inputValue = event.target.value;
    setQuery(inputValue);
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (inputValue.length > 0) {
        fetchSuggestions(inputValue);
      } else {
        setSuggestions([]);
      }
    }, 300); 
    meddraDetails.map(data => {
      if (data.current_idx == index) {
        if (event.target.value == "") {
          setMasterArray2({
            "meddra_llt_master_id": null,
                "meddra_mdhier_master_id":null,
          })
          setListFlag(false)
          data.meddraArray = []
          setValue("")
          data.searchTerm = ''
          setNoRecordsFlag(false)
          setDotsFlag(false)
          setEncodeMeddrabtn(true)
          data.medDRAEncode =true
          setMeddraDetails(meddraDetails)
          data.checkedMeddra=''
        } else {
          data.medDRAEncode =false
          setValue(event.target.value);
          data.searchTerm = event.target.value
          setEncodeMeddrabtn(true)
          setMeddraDetails(meddraDetails)
        }
      }
    })
  };
  
  const fetchSuggestions = async (searchQuery) => {
    axios
    .post(base_url + "meddra-master/fetch_all_llt_names_based_on_search_term",{"llt_name":searchQuery})
    .then((response) => {
    setSuggestions(response.data.data)
    setDotsFlag(false)
    if(response.data.data.length===0){
      setNoRecordsFlag(true)
    }
    })
  }
  const onSearch = (sTerm, index) => {
    setListFlag(false)
    setEncodeMeddrabtn(false)
    setValue(sTerm);
    meddraDetails.map((data, index1) => {
      if (data.current_idx == index) {
        data.searchTerm = sTerm
        data.medDRAEncode = true
        setMeddraDetails(meddraDetails)
      }
    })
  };  
  const handleCheckboxChange2 = (selectedCheckbox, index) => {
    let updatedData = [...meddraDetails]
    updatedData.map(i => {
      if(i.current_idx === index){
        i.checkedMeddra = selectedCheckbox.meddra_mdhier_master_id
      }
    })
    setMasterArray2({
        meddra_llt_master_id : selectedCheckbox.meddra_llt_master_id,
        meddra_mdhier_master_id : selectedCheckbox.meddra_mdhier_master_id
      })
    
    setMeddraDetails(updatedData)
  };

  return (
    <div>
      <div className="col right_contentt d-flex flex-column" >
              <div className="col d-flex  flex-column" style={{ maxHeight: "80vh",width:800, padding: "4rem 2rem 5rem 2rem" ,gap:"10px"}} >
                <div className="AE_input">
                  <label className="AE_labels" htmlFor="eventName">
                    Event Name<span className="text-danger">*</span>
                  </label>
                  <input
                    autoFocus
                    className=""
                    value={eventName}
                    id="eventName"
                    type="text"
                    placeholder="Enter event name"
                    onChange={handleAdverseEvent}
                  />
                </div>
                <div className="custom_select_main ">
                <Select
                  selectdivstyl={"AE_input"}
                  required={"*"}
                  name={"classification"}
                  width={"364px"}
                  label={"Event Classification"}
                  options={options}
                  initialValue={"Select Classification"}
                  onChange={handleOptionSelect}
                  className="main_mh adverse "  
               />
               </div> 
                <div className="AE_input mb-3">
                  <label className="AE_labels" htmlFor="eventName">
                    Case Definition
                  </label>
                  <input
                    className=""
                    id="eventName"
                    type="text"
                    placeholder={""}
                    value={
                      eventClass === EVENT_CLASSIFICATION_LEVEL_BRIGHTON
                        ? "Level"
                        : eventClass === EVENT_CLASSIFICATION_AESI
                          ? "AESI"
                          : eventClass === EVENT_CLASSIFICATION_GRADE_CTCAE
                            ? "Grade"
                            : ""
                    }
                    disabled
                    onChange={handleAdverseEvent}
                  />
                </div>

                {eventClass === EVENT_CLASSIFICATION_GRADE_CTCAE && (
                  <div className="textarea_btn_div">
                    <TransitionGroup>
                      {textAreas.map((textAreaValue, index) => {

                        return (
                          <CSSTransition nodeRef={myNodeRef} key={index} timeout={1000} classNames="fade">
                            <div className="textarea_item ">
                              {index !== 0 && <button
                                onClick={() => handleNewTextAreaDelete(textAreas, index)}
                                className="minus_btn"
                              >
                                <span>x</span>
                              </button>}
                              <textarea
                                value={textAreaValue}
                                onKeyDown={handleTextareaKeyDown}
                                onChange={(event) => handleTextAreaChange(index, event, textAreaValue)}
                                placeholder="Type event definition"
                              />
                            </div>
                          </CSSTransition>
                        )
                      })}
                    </TransitionGroup>
                    <button disabled={blankTextAreas} onClick={addTextArea} className="plus_btn">
                      <span>+</span>
                    </button>                   
                  </div>
                )} 

               
                {/* =====================Event meets case definition after API resp=================== */}
                {eventClass === EVENT_CLASSIFICATION_LEVEL_BRIGHTON && (
                  <div className="ct_event_main">
                    <EventMeetCase meetCaseDef={meetCaseDef} textAreaMeetCase={textAreaMeetCase} handleNewTextAreaDelete={handleNewTextAreaDelete} />
                    {/* =============== Event does not meet case definition after API resp================== */}
                    <EventNotMeetCase notMeetCaseDef={notMeetCaseDef} textAreasNotMeetCase={textAreasNotMeetCase} handleNewTextAreaDelete={handleNewTextAreaDelete} />
                  </div>
                )}
                {/* ================other============== */}
                {eventClass === EVENT_CLASSIFICATION_AESI && (
                  <div className="textarea_btn_div mb-3">
                    <Editor apiKey={TINY_API_KEY}
                      cloudChannel="5-stable"
                      disabled={false}
                      inline={false}
                      onEditorChange={handleEditorChange}
                      plugins=""
                      tagName="div"
                      textareaName="body"
                      toolbar="undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat forecolor backcolor"
                      value={othersTextArea}
                      outputFormat="html"
                      init={{
                        height: 250,
                        language: "en",
                        //menubar: false,
                        plugins: [
                          "advlist autolink lists link image charmap print preview anchor",
                          "searchreplace visualblocks code fullscreen",
                          "insertdatetime media table paste code help wordcount",
                        ],
                        convert_urls: false,
                        placeholder: "Type event definition"
                      }}
                      // Add aria-required attribute
                      aria-required={true}
                      name="others"
                      className="ae_other_option_textarea_editior" // Add the className attribute
                    />
                    </div>
                )}     

                <div className="mb-5 pb-5">


<MeddraDetails
        noRecordsFlag={noRecordsFlag}
        dotsFlag={dotsFlag}
        loadFlag={loadFlag}
        listFlag={listFlag}
          meddraDetails={meddraDetails}
          handleMeddraClassification1={handleMeddraClassification1}
          encodeMeddrabtn={encodeMeddrabtn}
          value={value}
          handleCheckboxChange2={handleCheckboxChange2}
          reviewedDtls={reviewedDtls}
          medView={medView}
          meddraClassification={meddraClassification}
          onEncode2={onEncode2}
          suggestions={suggestions}
          onSearch={onSearch} />

                </div>

              </div>
       
              <div className="AE_footer_event ">
              <div className="save_btn ">
              {eventClass === EVENT_CLASSIFICATION_GRADE_CTCAE && <button className="orange_btn" onClick={handleSaveEvent}
                disabled={eventName !== '' && eventClass !== '' && !textareaNotEmplty}>
                Save
              </button>}
              {eventClass === EVENT_CLASSIFICATION_LEVEL_BRIGHTON && <button className="orange_btn" onClick={handleSaveEvent}
                disabled={eventName !== '' && allValuesNotEmpty ? false : true}>
                Save
              </button>}
              {eventClass === EVENT_CLASSIFICATION_AESI &&
                <button className="orange_btn" onClick={handleSaveEvent}
                  disabled={eventName !== '' && othersTextArea !== '' ? false : true}>
                  Save
                </button>}
            </div>
            </div>
            </div>
            <PopUpAlert handleClose={() => setOpenDeleteNew(false)} open={openDeleteNew} title={"Confirm Delete!"} msg={"Are you sure you want to delete this!"} close={'Cancel'} actionbtn={'Delete'} onConfirm={deleteNewTextBoxes} />
    </div>
  )
}

export default PMSAddEvent
